module.exports = __webpack_public_path__ + "img/streamline.4164457f.svg";